import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { Focus, Maximize2, RotateCw, ZoomIn, ZoomOut } from "lucide-react";
import type { ZoomControlsProps } from "./types";

export const ZoomControls = ({
  onZoomIn,
  onZoomOut,
  onReset,
  onZoomToObject,
  onRotate,
  isDisabled,
  className,
}: ZoomControlsProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={clsx(
        "flex flex-col gap-1 rounded-lg border bg-white/95 backdrop-blur p-1 shadow-sm absolute bottom-3 right-3 z-20",
        className,
      )}
      onMouseDown={(e) => e.stopPropagation()}
      onTouchStart={(e) => e.stopPropagation()}
    >
      <button
        type="button"
        className={clsx(
          "h-7 px-2 text-xs rounded flex items-center gap-1 transition",
          isDisabled
            ? "text-gray-300 cursor-not-allowed"
            : "text-gray-700 hover:bg-gray-100",
        )}
        onClick={onZoomIn}
        disabled={isDisabled}
        aria-label={t("smartSurveyor.controls.zoom.in.aria")}
      >
        <ZoomIn size={14} strokeWidth={2.2} />
      </button>
      <button
        type="button"
        className={clsx(
          "h-7 px-2 text-xs rounded flex items-center gap-1 transition",
          isDisabled
            ? "text-gray-300 cursor-not-allowed"
            : "text-gray-700 hover:bg-gray-100",
        )}
        onClick={onZoomOut}
        disabled={isDisabled}
        aria-label={t("smartSurveyor.controls.zoom.out.aria")}
      >
        <ZoomOut size={14} strokeWidth={2.2} />
      </button>
      {!!onZoomToObject && (
        <button
          type="button"
          className={clsx(
            "h-7 px-2 text-xs rounded flex items-center gap-1 transition",
            isDisabled
              ? "text-gray-300 cursor-not-allowed"
              : "text-gray-700 hover:bg-gray-100",
          )}
          onClick={onZoomToObject}
          disabled={isDisabled}
          aria-label={t("smartSurveyor.controls.zoom.focus.aria")}
        >
          <Focus size={14} strokeWidth={2.2} />
        </button>
      )}
      <button
        type="button"
        className={clsx(
          "h-7 px-2 text-xs rounded flex items-center gap-1 transition",
          isDisabled
            ? "text-gray-300 cursor-not-allowed"
            : "text-gray-700 hover:bg-gray-100",
        )}
        onClick={onReset}
        disabled={isDisabled}
        aria-label={t("smartSurveyor.controls.zoom.reset.aria")}
      >
        <Maximize2 size={14} strokeWidth={2.2} />
      </button>
      {!!onRotate && (
        <button
          type="button"
          className={clsx(
            "h-7 px-2 text-xs rounded flex items-center gap-1 transition",
            isDisabled
              ? "text-gray-300 cursor-not-allowed"
              : "text-gray-700 hover:bg-gray-100",
          )}
          onClick={onRotate}
          disabled={isDisabled}
          aria-label={t("smartSurveyor.controls.zoom.rotate.aria")}
        >
          <RotateCw size={14} strokeWidth={2.2} />
        </button>
      )}
    </div>
  );
};
